import {
  GET_VENDOR_MEDIA_SUCCESS,
  GET_VENDOR_MEDIA_FAIL,
  GET_VENDOR_MEDIA_PROFILE_SUCCESS,
  GET_VENDOR_MEDIA_PROFILE_FAIL,
  ADD_VENDOR_MEDIA_SUCCESS,
  ADD_VENDOR_MEDIA_FAIL,
  UPDATE_VENDOR_MEDIA_SUCCESS,
  UPDATE_VENDOR_MEDIA_FAIL,
  DELETE_VENDOR_MEDIA_SUCCESS,
  DELETE_VENDOR_MEDIA_FAIL,
  DELETE_VENDOR_MEDIA,
  ADD_NEW_VENDOR_MEDIA,
  UPDATE_VENDOR_MEDIA
  
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  vendor_mediaProfile: {},
  error: {},
  loading:false
};

const vendor_media = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_VENDOR_MEDIA_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_VENDOR_MEDIA_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_VENDOR_MEDIA:
        return {
          ...state,
          loading:true
        }
    case ADD_VENDOR_MEDIA_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading:false
      }

    case ADD_VENDOR_MEDIA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_VENDOR_MEDIA:
        return {
          ...state,
          loading:true
        }
    case UPDATE_VENDOR_MEDIA_SUCCESS:
      return {
        ...state,
        data: state.data.map(d =>
          d.id.toString() === action.payload.id.toString()
            ? { ...d, ...action.payload }
            : d
        ),
        loading:false
      }

    case UPDATE_VENDOR_MEDIA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_VENDOR_MEDIA:
      return {
        ...state,
        loading:true
      }
    case DELETE_VENDOR_MEDIA_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          d => d.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_VENDOR_MEDIA_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VENDOR_MEDIA_PROFILE_SUCCESS:
      return {
        ...state,
        vendor_catProfile: action.payload,
      }

    case GET_VENDOR_MEDIA_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default vendor_media;
